import { QC, ElementFlags } from "./dt-schema";
import { matchClassification } from "./matchClassification";
import { TandemCategories } from "./TandemCategories";

export class AssetCheck {
  constructor(model, codesWithParam) {
    this.dbId2TandemCategory = model.getData().dbId2TandemCategory;
    this.dbId2Class = model.getData().dbId2Class;
    this.dbId2UfClass = model.getData().dbId2UfClass;
    this.dbId2flags = model.getData().dbId2flags;

    this.codesWithParam = codesWithParam;

    this.cache = {};
    // tandem category is not per model, we could cache it more globally
    if (codesWithParam[QC.TandemCategory]) {
      this.cache.taggableTc = new Set();
      const codes = codesWithParam[QC.TandemCategory];
      for (const code of codes) {
        const [c, cUpper] = TandemCategories.code2range(code);
        for (let i = c; i < cUpper; i++) {
          this.cache.taggableTc.add(i);
        }
      }
    }

    if (codesWithParam[QC.Classification] && !this.dbId2Class.isEmpty()) {
      // index 0 from flat string storage is empty.
      this.cache.dt = new Map([[0, false]]);
    }

    if (codesWithParam[QC.UniformatClass] && !this.dbId2UfClass.isEmpty()) {
      // index 0 from flat string storage is empty.
      this.cache.uf = new Map([[0, false]]);
    }
  }

  _matchHierarchy(attr, code) {
    return code && this.codesWithParam[attr].some((c) => matchClassification(code, c));
  }

  isAsset(dbId) {
    const flags = this.dbId2flags[dbId];
    if (flags > ElementFlags.CompositeParent && flags != ElementFlags.GenericAsset) {
      return false;
    }


    // tandem category
    if (this.cache.taggableTc?.has(this.dbId2TandemCategory[dbId])) {
      return true;
    }

    // user classification
    if (this.cache.dt) {
      const dt = this.dbId2Class.sid2idx[dbId];
      let isAsset = this.cache.dt.get(dt);
      if (isAsset === undefined) {
        const clsCode = this.dbId2Class.get(dt);
        isAsset = this._matchHierarchy(QC.Classification, clsCode);
        this.cache.dt.set(dt, isAsset);
      }

      if (isAsset) {
        return true;
      }
    }

    // assembly code (legacy models)
    if (this.cache.uf) {
      const uf = this.dbId2UfClass.sid2idx[dbId];
      let isAsset = this.cache.uf.get(uf);
      if (isAsset === undefined) {
        const assemblyCode = this.dbId2UfClass.get(uf);
        isAsset = this._matchHierarchy(QC.UniformatClass, assemblyCode);
        this.cache.uf.set(uf, isAsset);
      }

      if (isAsset) {
        return true;
      }
    }

    return false;
  }
}